if (!customElements.get('alcohol-cart-confirmation')) {
  class AlcoholCartConfirmation extends HTMLElement {
    connectedCallback() {
      this.checkbox = this.querySelector('input[type="checkbox"]');
      this.form = document.getElementById(this.dataset.form);
      if (!this.checkbox || !this.form) return;
      this.buttons = Array.from(this.form.elements).filter((element) => element.name === 'checkout');
      this.update = () => {
        this.buttons.forEach((button) => { button.disabled = !this.checkbox.checked; });
      };
      this.reset = () => { this.checkbox.checked = false; this.update(); };
      this.guard = (event) => {
        if ((!event.submitter || event.submitter.name === 'checkout') && !this.checkbox.checked) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.checkbox.reportValidity();
          this.checkbox.focus();
        } else if (!event.submitter || event.submitter.name === 'checkout') {
          // Let the browser capture the checked declaration before resetting another attempt.
          setTimeout(this.reset, 0);
        }
      };
      this.checkbox.addEventListener('change', this.update);
      this.form.addEventListener('submit', this.guard, true);
      window.addEventListener('pageshow', this.reset);
      this.reset();
    }
    disconnectedCallback() {
      this.checkbox?.removeEventListener('change', this.update);
      this.form?.removeEventListener('submit', this.guard, true);
      window.removeEventListener('pageshow', this.reset);
    }
  }
  customElements.define('alcohol-cart-confirmation', AlcoholCartConfirmation);
}

